import React from 'react'
import {
  Show,
  TextField,
  ArrayField,
  Datagrid,
} from 'react-admin';
import { Box } from '@mui/material';
import SelfLinkField from '../../components/SelfLinkField';

const HorseShow = (props) => {
  return (
    <Show {...props} title="Horse Details">
      <Box display="flex" flexDirection="column" gap={2} padding={2}>
        <TextField source="external_id" label="ID" />
        <TextField source="name" />
        <TextField source="sire_name" label="Sire name" />
        <TextField source="dam_name" label="Dam name" />
        <TextField source="dam_sire_name" label="Dam sire name" />
        <TextField source="sire_number" label="Sire number" />
        <TextField source="rfid" label="RFID" />
        <TextField source="sex" />
        <TextField source="birthdate" label="Birthdate" />
        <TextField source="owner" label="Owner" />

        <ArrayField source="vet_cases">
          <Datagrid bulkActionButtons={false}>
            <SelfLinkField source="id" resource="vet_cases" label="Vet case" />
            <TextField source="case_number" label="Case number" />
          </Datagrid>
        </ArrayField>
      </Box>
    </Show>
  );
};

export default HorseShow;
